import { render, staticRenderFns } from "./ChannelBatchCreate.vue?vue&type=template&id=4cb4e014&scoped=true&"
import script from "./ChannelBatchCreate.vue?vue&type=script&lang=js&"
export * from "./ChannelBatchCreate.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBatchCreate.vue?vue&type=style&index=0&id=4cb4e014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4e014",
  null
  
)

export default component.exports